// @flow
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { prefetchI18nStrings } from 'common/components/TranslationsFetcher';

import useEffectOnce from 'common/hooks/useEffectOnce';
import useClientId from 'common/hooks/useClientId';
import usePersonnel from 'common/hooks/usePersonnel';

import { getSelectedBUId } from 'common/redux/selectors/appPreferences';

const PrefetchData = (): React.Node => {
    const clientId = useClientId();
    const personnel = usePersonnel();
    const match = useRouteMatch();
    const selectedBUId = useSelector(state =>
        getSelectedBUId(state, { match })
    );

    useEffectOnce(() => {
        // prefetching i18n strings to speed up page load
        prefetchI18nStrings({
            clientId,
            language: personnel.language,
            businessUnitId: selectedBUId
        });
    });

    return null;
};

export default PrefetchData;
